import {createSelector} from 'reselect'
import {getWorkflowStatuses} from '../../entities/selectors'
import {prepareWorkflowStatusesForPage} from './utils'

export const getWorkflowSettings = state => state.workflowSettings

export const isFirstLoading = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.firstLoading
)

export const isLoading = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.loading
)

export const getStatusesInUseIds = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.statusesInUseIds
)

export const getPageStatuses = createSelector(
    getStatusesInUseIds,
    getWorkflowStatuses,
    (statusesInUseIds, statusesMap) => {
        return prepareWorkflowStatusesForPage(statusesInUseIds, statusesMap)
    }
)

export const isShowEditStatusDialog = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.showEditStatusDialog
)

export const getEditDialogData = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.editingStatus
)

export const getErrors = createSelector(
    getWorkflowSettings,
    (wfs) => wfs.errors
)



// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/selectors.js